import React from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import WorkPriceInput from './WorkPriceInput';

const { Option } = Select;
const label = (t) => <span style={{ fontFamily: 'CustomFont' }}>{t}</span>;

/** فیلدهای سفارشی از پاسخ create/edit — نام فرم: cf_{id} */
export const workCustomFieldFormName = (field) => `cf_${field.id ?? field.name}`;

export const extractWorkCustomFieldsPayload = (values, fields = []) => {
  const out = {};
  fields.forEach((f) => {
    const key = workCustomFieldFormName(f);
    if (values[key] !== undefined && values[key] !== '') {
      const apiKey = f.name || f.field_name || key;
      out[apiKey] = values[key];
    }
  });
  return out;
};

export const mapWorkCustomFieldsToForm = (fields = [], data = {}) => {
  const initial = {};
  fields.forEach((f) => {
    const key = workCustomFieldFormName(f);
    const apiKey = f.name || f.field_name;
    initial[key] = data[apiKey] ?? f.value ?? f.default_value;
  });
  return initial;
};

const WorkCustomFields = ({ fields = [] }) => {
  if (!fields?.length) return null;

  return (
    <div className="mt-2 mb-4">
      <h3 className="text-base font-semibold mb-3" style={{ fontFamily: 'CustomFont' }}>
        فیلدهای سفارشی
      </h3>
      <Row gutter={[16, 0]}>
        {fields.map((f) => {
          const name = workCustomFieldFormName(f);
          const rules = f.required ? [{ required: true, message: 'الزامی است' }] : [];
          const type = (f.type || 'text').toLowerCase();

          if (type === 'number' || type === 'currency' || type === 'price') {
            return (
              <Col xs={24} sm={12} key={f.id ?? name}>
                <Form.Item name={name} label={label(f.label || f.name)} rules={rules}>
                  <WorkPriceInput />
                </Form.Item>
              </Col>
            );
          }

          if (type === 'select' && Array.isArray(f.values)) {
            return (
              <Col xs={24} sm={12} key={f.id ?? name}>
                <Form.Item name={name} label={label(f.label || f.name)} rules={rules}>
                  <Select allowClear>
                    {f.values.map((opt) => (
                      <Option key={String(opt)} value={opt}>
                        {opt}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            );
          }

          return (
            <Col xs={24} sm={12} key={f.id ?? name}>
              <Form.Item name={name} label={label(f.label || f.name)} rules={rules}>
                <Input />
              </Form.Item>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default WorkCustomFields;
